const _version = "2.6.0"
function version() {
    return _version;
}
export default version
